<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="编码">
              <a-input :placeholder="$t('label.pleaseEnterTheCode')" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="描述">
              <a-input placeholder="请输入描述" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="操作分组">
                <a-input placeholder="请输入操作分组" v-model="queryParam.category"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="移动类型">
                <a-input placeholder="请输入移动类型" v-model="queryParam.moveType"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('efs_md_operation_type')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('button.delete') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('tip.selected') }} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)"> {{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-operation-type-modal ref="modalForm" @ok="modalFormOk"></efs-md-operation-type-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdOperationTypeModal from './modules/EfsMdOperationTypeModal'

  export default {
    name: 'EfsMdOperationTypeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsMdOperationTypeModal
    },
    data () {
      return {
        description: 'efs_md_operation_type管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'编码',
            align:"center",
            dataIndex: 'code'
          },
          {
             slotName: 'tableHeader.description',
            scopedSlots: { title: 'tableHeader.description'},
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'操作分组',
            align:"center",
            dataIndex: 'category'
          },
          {
            title:'科目',
            align:"center",
            dataIndex: 'account'
          },
          {
            title:'移动类型',
            align:"center",
            dataIndex: 'moveType'
          },
          {
            title:'第三方系统编码',
            align:"center",
            dataIndex: 'thirdSysCode'
          },
          {
            slotName: 'tableHeader.syncStatus',
                        scopedSlots: { title: 'tableHeader.syncStatus'},
            align:"center",
            dataIndex: 'syncStatus'
          },
          {
            slotName: 'tableHeader.syncMessage',
                        scopedSlots: { title: 'tableHeader.syncMessage'},
            align:"center",
            dataIndex: 'syncMsg'
          },
          {
            title:'锁定标记',
            align:"center",
            dataIndex: 'lockStatus'
          },
          {
            slotName: 'tableHeader.remarks',
            scopedSlots: { title: 'tableHeader.remarks'},
            align:"center",
            dataIndex: 'notes'
          },
          {
            title:'租户信息',
            align:"center",
            dataIndex: 'tenantCode'
          },
          {
            title:'排序字段',
            align:"center",
            dataIndex: 'sortOrder'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/system/efsMdOperationType/list",
          delete: "/system/efsMdOperationType/delete",
          deleteBatch: "/system/efsMdOperationType/deleteBatch",
          exportXlsUrl: "/system/efsMdOperationType/exportXls",
          importExcelUrl: "system/efsMdOperationType/importExcel",

        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'code',text:'编码',dictCode:''})
        fieldList.push({type:'string',value:'name',text:'描述',dictCode:''})
        fieldList.push({type:'string',value:'category',text:'操作分组',dictCode:''})
        fieldList.push({type:'string',value:'account',text:'科目',dictCode:''})
        fieldList.push({type:'string',value:'moveType',text:'移动类型',dictCode:''})
        fieldList.push({type:'string',value:'thirdSysCode',text:'第三方系统编码',dictCode:''})
        fieldList.push({type:'string',value:'syncStatus',text:'同步状态',dictCode:''})
        fieldList.push({type:'string',value:'syncMsg',text:'同步消息',dictCode:''})
        fieldList.push({type:'string',value:'lockStatus',text:'锁定标记',dictCode:''})
        fieldList.push({type:'string',value:'buffer1',text:'拓展属性',dictCode:''})
        fieldList.push({type:'string',value:'buffer2',text:'拓展属性',dictCode:''})
        fieldList.push({type:'string',value:'buffer3',text:'拓展属性',dictCode:''})
        fieldList.push({type:'string',value:'buffer4',text:'拓展属性',dictCode:''})
        fieldList.push({type:'string',value:'buffer5',text:'拓展属性',dictCode:''})
        fieldList.push({type:'string',value:'notes',text:'备注',dictCode:''})
        fieldList.push({type:'string',value:'tenantCode',text:'租户信息',dictCode:''})
        fieldList.push({type:'int',value:'sortOrder',text:'排序字段',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>